"use strict";
(() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      if (__hasOwnProp.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b)) {
        if (__propIsEnum.call(b, prop))
          __defNormalProp(a, prop, b[prop]);
      }
    return a;
  };

  var rules = [
    {
      match: (elem) => {
        return hasClass(elem, "shopify-payment-button__button") && !!elem.querySelector(`div[data-testid="PayPalInContext-button"]`);
      },
      matched: () => {
          trackEvent("click_buy_with_paypal");
      }
    },
    {
      match: (elem) => {
        return hasClass(elem, "shopify-payment-button__more-options") && elem.nodeName.toLowerCase() === "button";
      },
      matched: () => {
          trackEvent("click_more_payment_options");
      }
    }
  ];
  function trackEvent(eventName, eventParams) {
    if (typeof gtag === "function") {
      gtag("event", eventName, __spreadValues({
        page_location: location.href,
        page_path: location.pathname,
        page_title: document.title,
        send_to: ["G-LPB8J6RJ15"]
      }, eventParams || {}));
    }
  }
  function hasClass(element, className) {
    return element.classList.contains(className);
  }
  function onClickWindow(event) {
    var target = event.target;
    if (target && target.nodeType === 1) {
      var element = target;
      var notPassedRules = rules;
      while (element && element !== document.body) {
        var matchingRules = notPassedRules;
        notPassedRules = [];
        matchingRules.forEach((rule) => {
          if (element) {
            try {
              if (rule.match(element, event)) {
                rule.matched(element, event);
              } else {
                notPassedRules.push(rule);
              }
            } catch (err) {
              console.error(err);
            }
          }
        });
        if (!notPassedRules.length) {
          break;
        }
        element = element.parentElement;
      }
    }
  }
  window.addEventListener("click", onClickWindow, true);
})();
